import React from "react"
import { QRCodeSVG } from "qrcode.react"
import { Modal, Space, Button, Typography, message } from "@mimber/ui-web"
import { SyncOutlined } from "@mimber/ui-web"
import { useRegenerateEventQr } from "@mimber/client/mimber-organization"
import type { EventQrCodeDisplayProps } from "./EventQrCodeDisplay.types"

const { Text } = Typography

export const EventQrCodeDisplay: React.FunctionComponent<
  EventQrCodeDisplayProps
> = ({ eventUuid, qrCheckInToken, ...modalProps }) => {
  const regenerate = useRegenerateEventQr(eventUuid, {
    onSuccess: () => {
      message.success("QR code regenerated. The old code is now invalid.")
    },
    onError: () => {
      message.error("Failed to regenerate QR code")
    },
  })

  return (
    <Modal footer={null} title="Event Check-In QR Code" {...modalProps}>
      {(close) => (
        <Space
          orientation="vertical"
          size="large"
          style={{ width: "100%", alignItems: "center", textAlign: "center" }}
        >
          <QRCodeSVG value={qrCheckInToken} size={256} />
          <Text type="secondary" style={{ fontSize: 12 }}>
            Display this QR code at your event for attendees to scan
          </Text>
          <Space>
            <Button
              icon={<SyncOutlined />}
              loading={regenerate.isPending}
              danger
              onClick={() => regenerate.mutate()}
            >
              Regenerate QR
            </Button>
            <Button onClick={close}>Close</Button>
          </Space>
        </Space>
      )}
    </Modal>
  )
}
